/**
 * components/Loading
 * ──────────────────────────────────────────────────────────────────────────
 * The in-flight state. The design specifies none — it was drawn against
 * in-memory data — so this is deliberately the quietest thing that still tells
 * the truth: one ink indicator, centred, on the page background.
 *
 * No skeletons. A skeleton of a cash position implies figures that are not
 * there yet, and in a subledger a shape where a number should be is worse than
 * an honest blank.
 * ──────────────────────────────────────────────────────────────────────────
 */
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';
import { neutral } from '../../theme/colors';
import { sans, size as fontSize } from '../../theme/typography';

export interface LoadingProps {
  /** A line under the indicator, for waits the user initiated. */
  label?: string;
  /** Fill the viewport rather than sitting inline in a card. */
  full?: boolean;
}

export function Loading({ label, full = false }: LoadingProps) {
  return (
    <View style={[styles.wrap, full ? styles.full : styles.inline]}>
      <ActivityIndicator size="small" color={neutral.ink} />
      {!!label && <Text style={styles.label}>{label}</Text>}
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { alignItems: 'center', justifyContent: 'center', gap: 10 },
  full: { flex: 1, backgroundColor: neutral.surface },
  inline: { paddingVertical: 48 },
  label: { ...sans('400'), fontSize: fontSize.button, color: neutral.grey600 },
});

export default Loading;
